// import history from "history.js";
import axios from "axios";
import { get, post } from "../baseApi";
import { error, success } from "../../../views/utilities/Toast/Toast";
import { authHeaderWithToken, authHeaderWithOutToken } from "../AxiosHeader";
import UrlConfig from "./UrlConfig";

export const PDO_STAGE3_LOADING = "PDO_STAGE3_LOADING";
export const PDO_STAGE3_SUCCESS = "PDO_STAGE3_SUCCESS";
export const PDO_STAGE3_ERROR = "PDO_STAGE3_ERROR";

export const createOrUpdatePDOStage3 = (payload) => async (dispatch) => {
  let url = UrlConfig.CreateOrUpdatePDOStage3URL();

  dispatch({
    type: PDO_STAGE3_LOADING
  });

  let header = authHeaderWithToken();
  let res = await post(url, payload, header);
  if (res && res.status === 200) {
    //res && res.data
    success("PDO updated successfully...");
    dispatch({
      type: PDO_STAGE3_SUCCESS,
      //data: user//res.data
    });
    return true;
  } else if (res && res.isAxiosError) {
    if (res.response && res.response.data && res.response.data.message) {
      error(res.response.data.message);
    } else {
      error("Error while Submitting PDO...");
    }
    dispatch({
      type: PDO_STAGE3_ERROR
      //payload: res.isAxiosError
    });
    return false;
  }
};
